import * as React from 'react';
import { stateFromMarkdown } from 'draft-js-import-markdown';
import { stateToHTML } from 'draft-js-export-html';
import { env } from '@dx-ui/framework-env';
import { CarouselSingle } from '@dx-ui/osc-carousel';
import type { EventContent } from '../../hooks/useEventData';
import type { ContentState } from 'draft-js';
import { SanitizedHtml } from '@dx-ui/osc-sanitized-html';

export type IProps = {
  description: string;
  isPreviewView: boolean;
  images: EventContent['images'];
};

const PreviewBody: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { description: markDownText, images, isPreviewView } = props;
  const stateFromText: ContentState = stateFromMarkdown(markDownText || '');
  const description = stateToHTML(stateFromText);
  const [uploadedImages, setUploadedImages] = React.useState<string[]>([]);

  React.useEffect(() => {
    const getImageURL = () =>
      images.map((image) => {
        const imageURL =
          image.url?.replace('/image/upload/', `/image/upload/c_mfit,h_463,q_auto:good,w_700/`) ||
          '';
        return !isPreviewView && image.status === 'pending'
          ? `${env('HILTON_ASSETS_URI')}/modules/assets/img/common/no-photo-available.png`
          : imageURL;
      });

    if (images?.length) {
      setUploadedImages(getImageURL());
    }
  }, [images, isPreviewView]);

  const carouselImages = uploadedImages.map((item) => ({
    url: item,
    alt: item.split('/').pop() || '',
  }));

  return (
    <div className="flex flex-wrap">
      {images.length ? (
        <div className="w-full lg:order-2 lg:w-1/2">
          {carouselImages.length ? (
            <CarouselSingle
              images={carouselImages}
              className="aspect-[3/2] [&_img]:!bg-surface [&_img]:!object-contain"
            />
          ) : (
            <div className="aspect-[3/2]" />
          )}
        </div>
      ) : null}
      <SanitizedHtml
        className="description-container block flex-1 bg-surface pr-0 pt-4 leading-normal flex-basis-1/2 md:pr-4 md:pt-0 lg:order-1"
        html={description}
      />
    </div>
  );
};

export default PreviewBody;
